module.exports = __webpack_public_path__ + "img/home.7af20470.svg";